import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  label: string
  minutes: number
  description: string
  displayBreakdown?: boolean
  children: React.ReactNode
}

const ItemsBox = ({ label, minutes, description, displayBreakdown = true, children }: Props) => {
  return (
    <Box gap="s8" paddingY="s12">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s2">
        <Text size="300" weight="medium">
          {label}
        </Text>

        <MinutesToText value={minutes} size="300" weight="medium" />
      </Box>

      <Text size="200">{description}</Text>
      {displayBreakdown && (
        <Box
          border={{
            all: {
              width: 's1',
              color: 'grey400',
              style: 'solid',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          background="grey200"
          padding="s16"
        >
          {children}
        </Box>
      )}
    </Box>
  )
}

export default ItemsBox
